import { Details } from "~/entities/Details";

export default function (response, stageDetail: Details): Details {
  try {
    const validAddress = response.validAddress;
    const originalAddress = response.originalAddress;
    if (validAddress && response.success) {
      if (validAddress.company) {
        stageDetail.company = validAddress.company;
      } else if (originalAddress && originalAddress.company) {
        stageDetail.company = originalAddress.company;
      }
      if (validAddress.address1 && (validAddress.address1 as string).trim()) {
        stageDetail.streetAddress = validAddress.address1.trim();
        stageDetail.address1 = validAddress.address1.trim();
      } else if (
        originalAddress &&
        (originalAddress.address1 as string).trim()
      ) {
        stageDetail.address1 = originalAddress.address1.trim();
      }
      if (validAddress.address2) {
        stageDetail.address2 = validAddress.address2.trim();
      } else if (originalAddress && originalAddress.address2) {
        stageDetail.address2 = originalAddress.address2.trim();
      }
      if (validAddress.address3) {
        stageDetail.address3 = validAddress.address3;
      } else if (originalAddress && originalAddress.address3) {
        stageDetail.address3 = originalAddress.address3;
      }
      if (validAddress.city) {
        stageDetail.city = validAddress.city;
      } else if (originalAddress && originalAddress.city) {
        stageDetail.city = originalAddress.city;
      }
      if (validAddress.state && stageDetail.state) {
        stageDetail.state.stateprovcode = validAddress.state;
      } else if (originalAddress && originalAddress.state) {
        stageDetail.state.stateprovcode = originalAddress.state;
      }
      if (validAddress.postalCode) {
        stageDetail.postalCode = validAddress.postalCode;
      } else if (originalAddress && originalAddress.postalCode) {
        stageDetail.postalCode = originalAddress.postalCode;
      }
      if (validAddress.countryCode && stageDetail.country) {
        stageDetail.country.code = validAddress.countryCode;
      } else if (originalAddress && originalAddress.countryCode) {
        stageDetail.country.code = originalAddress.countryCode;
      }
    } else if (originalAddress) {
      if (originalAddress.company) {
        stageDetail.company = originalAddress.company;
      }
      if (
        originalAddress.address1 &&
        (originalAddress.address1 as string).trim()
      ) {
        stageDetail.streetAddress = originalAddress.address1.trim();
        stageDetail.address1 = originalAddress.address1.trim();
      }
      if (originalAddress.address2) {
        stageDetail.address2 = originalAddress.address2.trim();
      }
      if (originalAddress.address3) {
        stageDetail.address3 = originalAddress.address3;
      }
      if (originalAddress.city) {
        stageDetail.city = originalAddress.city;
      }
      if (originalAddress.state && stageDetail.state) {
        stageDetail.state.stateprovcode = originalAddress.state;
      }
      if (originalAddress.postalCode) {
        stageDetail.postalCode = originalAddress.postalCode;
      }
      if (originalAddress.countryCode && stageDetail.country) {
        stageDetail.country.code = originalAddress.countryCode;
      }
    }
    // flags
    if (response.success !== undefined) {
      stageDetail.success = response.success;
    }
    if (response.passedAvs !== undefined) {
      stageDetail.passedAvs = response.passedAvs;
    }
    if (response.errorCode !== undefined) {
      stageDetail.errorCode = response.errorCode;
    }
    if (response.errorMessage !== undefined) {
      stageDetail.errorMessage = response.errorMessage;
    }
    if (response.isChanged !== undefined) {
      stageDetail.isChanged = response.isChanged;
    }
    if (response.isResidential !== undefined) {
      stageDetail.isResidential = response.isResidential;
    }
    if (response.validationLevel !== undefined) {
      stageDetail.validationLevel = response.validationLevel;
    }
    if (response.validationSource !== undefined) {
      stageDetail.validationSource = response.validationSource;
    }
    return stageDetail;
  } catch (e) {
    return stageDetail;
  }
}
